import { useGetHttp } from "../../../../hooks/http/http.hook";
import type { IAssetMinimal } from "../../../../types/models/asset.models.types";
import type { IBrand } from "../../../../types/models/brands.models.types";
import type { ICampaignMetrics } from "../../../../types/models/campaign-metrics.types";
import type {  SocialPostType } from "../../../../types/models/campaign.models.types";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import type {
  SocialCreatorType,
  SocialGender,
  SocialPlatforms,
} from "../../../../types/models/social.models.types";
import type { MilestoneRewardType } from "../../../../z/brand/campaign-form.brand.z";
import type { IAsset } from "./update-brand-campaign.hook";

export enum CampaignStatus {
  live = "live",
  brandDraft = "brandDraft",
  ended = "ended",
}

export interface IProduct {
  image: IAsset;
  name: string;
  description: string;
}

export interface IBrandCampaign {
  id: string;
  brand: IBrand;
  name: string;
  campaignStatus: {
    status: CampaignStatus;
    message: string;
    timestamp: string;
  };
  coverImage: IAssetMinimal;
  socialPlatform: SocialPlatforms;
  socialPostType: SocialPostType;
  socialCreatorType: SocialCreatorType;
  startDate: string;
  endDate: string;
  budget: number;
  minimumFollowers: number;
  maximumFollowers: number;
  genderPreference: SocialGender;
  hashtags: string;
  mentions: string;
  aboutCampaign: string;
  campaignBrief: string;
  aboutBrand: string;
  do: string;
  dont: string;
  metrics: ICampaignMetrics;
  aboutPayment: string;
  milestoneType: string;
  assets: IAsset[];
  milestoneRewardType: MilestoneRewardType
  milestones: {
    count: number;
    payout: number;
    product: IProduct | null;
  }[];
  milestoneHasRefund: boolean;
  links: {
    title: string;
    url: string;
  }[];
}

interface IResponse {
  campaigns: IBrandCampaign[];
  pagination: IPagination;
}

export function useGetBrandCampaignHttp() {
  return useGetHttp<IResponse>({
    path: "/brand/campaigns",
  });
}
